<template>
    <div class="hero-section">
        <div class="container-full">
            <div class="hero-container">
                <div class="bulk-title">
                    <div class="row">
                        <div class="col-xs-12">
                            <p class="hero-title text-upper">
                                Purchasing in bulk for your business?<br>
                                We're here to help.
                            </p>
                        </div>
                        <div class="col-xs-12">
                            <p>You will receive an e-mail from us within two business days after you submit the query.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 contact-information">
                            <div class="feedback-image">
                                <img src="/images/bulk-purchase/feedback.svg" alt="Feedback icon" width="49" height="41" class="img-responsive">
                            </div>
                            <div class="feedback-contact">
                                <p class="phone-number">+1(626) 346-8261</p>
                                <p class="font-14">Mon to Fri, 10am–6pm, Pacific Time</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bulk-form" ref="bulk-purchase-form">
                    <div class="form-container">
                        <div class="row">
                            <div class="col-xs-12">
                                <h3 class="form-title">BULK PURCHASE QUERY</h3>
                            </div>
                        </div>
                        <div class="row" :class="{ 'form-submitted-container': isQuerySubmitted }">
                            <div class="col-xs-12">
                                <div class="container-full">
                                    <form v-if="!isQuerySubmitted" data-vv-scope="bulk-purchase-form" @submit.prevent="submitQuery">
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="form-group" :class="{ 'has-error': errors.has('bulk-purchase-form.name') }">
                                                    <p class="input-label">
                                                        Your Name
                                                        <span :class="{ 'text-danger': errors.has('bulk-purchase-form.name') }">(required)</span>
                                                    </p>
                                                    <input 
                                                        v-model="name"
                                                        v-validate="'required'" 
                                                        data-vv-name="name"
                                                        type="text" 
                                                        class="form-control"
                                                    >
                                                    <p v-if="errors.has('bulk-purchase-form.name')" class="help-block text-danger">
                                                        {{ errors.first('bulk-purchase-form.name') }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="form-group" :class="{ 'has-error': errors.has('bulk-purchase-form.email') }">
                                                    <p class="input-label">
                                                        Your Email
                                                        <span :class="{ 'text-danger': errors.has('bulk-purchase-form.email') }">(required)</span>
                                                    </p>
                                                    <input 
                                                        v-model="email"
                                                        v-validate="'required|email'" 
                                                        data-vv-name="email"
                                                        type="email" 
                                                        class="form-control"
                                                    >
                                                    <p v-if="errors.has('bulk-purchase-form.email')" class="help-block text-danger">
                                                        {{ errors.first('bulk-purchase-form.email') }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="form-group" :class="{ 'has-error': errors.has('bulk-purchase-form.company') }">
                                                    <p class="input-label">
                                                        Company
                                                        <span :class="{ 'text-danger': errors.has('bulk-purchase-form.company') }">(required)</span>
                                                    </p>
                                                    <input 
                                                        v-model="company"
                                                        v-validate="'required'" 
                                                        data-vv-name="company"
                                                        type="text" 
                                                        class="form-control"
                                                    >
                                                    <p v-if="errors.has('bulk-purchase-form.company')" class="help-block text-danger">
                                                        {{ errors.first('bulk-purchase-form.company') }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="form-group">
                                                    <p class="input-label">Any details</p>
                                                    <p class="help-label font-14">Your requirements, parts list, timeline, payment type, etc.</p>
                                                    <textarea v-model="details" class="form-control bulk-form-textarea" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <button type="submit" class="btn btn-block request-builds-btn">Submit query</button>
                                            </div>
                                        </div>
                                    </form>
                                    <div v-else class="form-submitted">
                                        <div class="form-submitted-item">
                                            <img src="/images/bulk-purchase/check.svg" alt="Check icon" width="64" height="45" class="img-responsive">
                                        </div>
                                        <div class="form-submitted-item">
                                            <p class="submitted-text">Thanks! You will receive an e-mail from us within two business days.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
const KLAVIYO_FIELDS = [
    "$source",
    "$name",
    "$email",
    "$company",
    "$details",
    "$consent_method",
    "$consent_form_id",
    "$consent_form_version"
];

export default {
    name: "HeroSection",
    $_veeValidate: {
        validator: "new"
    },
    data() {
        return {
            name: "",
            email: "",
            company: "",
            details: "",
            isQuerySubmitted: false
        }
    },
    mounted() {
        this.registerHeroSectionRefs();
    },
    methods: {
        async submitQueryToKlaviyo() {
            const data = new FormData();
            data.append("g", process.env.MIX_KLAVIYO_B2B_PURCHASE);
            data.append("$fields", KLAVIYO_FIELDS.join(","));
            data.append("$source", "B2B Bulk Purchase");
            data.append("$name", this.name);
            data.append("$email", this.email);
            data.append("$company", this.company);
            data.append("$details", this.details);

            const { data: { success } } = await axios({
                url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                method: "POST",
                data,
                headers: { "Content-Type": "multipart/form-data" }
            });

            return success;
        },
        async submitQuery() {
            const isValid = await this.$validator.validate("bulk-purchase-form.*");
            if(isValid) {
                const submitted = await this.submitQueryToKlaviyo();
                this.isQuerySubmitted = submitted;
            }
            
        },
        registerHeroSectionRefs() {
            const scrollableRefs = [
                {
                    name: "bulk-purchase-form",
                    el: this.$refs["bulk-purchase-form"]
                }
            ];
            this.$emit("registerScrollRefs", scrollableRefs);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

/* MOBILE */
.hero-section {
    padding: 32px 5px;
    background-image: url("/images/bulk-purchase/hero-background.jpg");
    background-size: cover;

    .help-block {
        font-size: 13px;
        margin: 5px 0;
    }

    .hero-container {
        display: flex;
        flex-flow: row wrap;
        padding: 0 16px;

        .bulk-title {
            flex-basis: 100%;
            order: 1;
            color: $white;

            .hero-title {
                font-size: 32px;
                font-weight: 600;
                margin: 0;
            }

            .contact-information {
                display: flex;
                flex-flow: row wrap;
                align-items: center;
                margin-top: 1rem;
                margin-bottom: 3rem;

                .feedback-image {
                    flex-basis: 16%;
                }

                .feedback-contact {
                    flex-basis: 83%;
                    
                    p {
                        padding: 0;
                        margin: 0;
                    }

                    .phone-number {
                        font-weight: 600;
                    }
                }
            }
        }

        .bulk-form {
            flex-basis: 100%;
            order: 2;
            
            .form-container {
                background-color: $white;
                color: $dark;
                border-radius: 2px;
                padding: 30px 16px;

                .has-error .form-control {
                    border-color: #D0021B;
                }

                .text-danger {
                    color: #D0021B;
                }

                .form-title {
                    font-size: 24px;
                    margin: 0 0 25px;
                }

                .input-label {
                    margin: 0;
                    font-weight: 500;
                }

                .help-label {
                    color: #5F707F;
                }

                .bulk-form-textarea {
                    min-height: 168px;
                    resize: none;
                }

                .request-builds-btn {
                    font-family: "Akkurat-normal", sans-serif;
                    line-height: 19px;
                    font-size: 16px;
                }

                .form-submitted-container {
                    display: flex;
                    align-items: center;
                    min-height: 566px;

                    .form-submitted {
                        display: flex;
                        flex-flow: row wrap;
                        justify-content: center;
                        align-items: center;

                        .form-submitted-item {
                            flex-basis: 100%;
                            display: flex;
                            flex-flow: row wrap;
                            justify-content: center;

                            .submitted-text {
                                text-align: center;
                                padding-top: 15px;
                                font-size: 14px;
                                color: #5E5C6E;
                            }
                        }
                    }
                }
            }
        }
    }
}

/* WIDE MOBILE */
@media screen and (min-width: 420px) {
    .hero-section .hero-container .bulk-title .contact-information {
        .feedback-image {
            flex-basis: auto;
            margin-right: 2%;
        }

        .feedback-contact {
            flex-basis: auto;
        }
    }
}

/* TABLET */
@media screen and (min-width: 768px) {
    .hero-section {
        padding: 32px 10px;
        background-image: url("/images/bulk-purchase/hero-background@2x.jpg");
        background-position: center;

        .hero-container {
            justify-content: space-around;
            align-items: center;
            padding: 0 10px;

            .bulk-title {
                flex-basis: 45%;
                order: 2;

                .contact-information {
                    padding-bottom: 1rem;
                    
                    .feedback-image {
                        flex-basis: 15%;
                    }

                    .feedback-contact {
                        flex-basis: 83%;
                    }
                }
            }

            .bulk-form {
                flex-basis: 45%;
                order: 1;

                .form-container .form-submitted-container {
                    min-width: 342px;

                    .form-submitted .form-submitted-item .submitted-text {
                        font-size: 15px;
                    }
                }
            }
        
        }
    }
}

/* TABLET & DESKTOP */
@media screen and (min-width: 1024px) {
    .hero-section {
        padding: 64px 10px;

        .hero-container {
            padding: initial;

            .bulk-title {
                order: 2;
                flex-basis: 50%;
                padding-left: 30px;

                .hero-title {
                    font-size: 48px;
                }
                
                .contact-information {
                    .feedback-image {
                        flex-basis: 12%;
                    }

                    .feedback-contact {
                        flex-basis: 86%;
                    }
                }
            }

            .bulk-form {
                order: 1;
                flex-basis: 45%;
                display: flex;
                justify-content: center;

                .form-container {
                    max-width: 448px;
                    padding: 30px;

                    .request-builds-btn {
                        font-size: 17px;
                    }

                    .form-submitted-container {
                        min-width: initial;
                        min-height: 544px;

                        .form-submitted .form-submitted-item .submitted-text {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}

/* DESKTOP */
@media screen and (min-width: 1366px) {
    .hero-section {
        background-position: initial;
        
        .hero-container {
            justify-content: center;

            .bulk-title {
                padding-left: 70px;
                flex-basis: 45%;

                .contact-information {
                    .feedback-image {
                        flex-basis: 10%;
                    }

                    .feedback-contact {
                        flex-basis: 88%;
                    }
                }
            }

            .bulk-form {
                flex-basis: 40%;

                .form-container .form-submitted-container {
                    min-width: 418px;
                }
            }
        }
    } 
}

/* FULL DESKTOP */
@media screen and (min-width: 1900px) {
    .hero-section .hero-container {
        .bulk-title .contact-information {
            .feedback-image {
                flex-basis: 8%;
            }

            .feedback-contact {
                flex-basis: 90%;
            }
        }
        
        .bulk-form {
            flex-basis: 30%;
        }
    }
}
</style>
